<app-module-navbar [items]="navItems">
</app-module-navbar>